import { Cardy } from '@stenajs-webui/elements';
import type { PropsWithChildren } from 'react';

interface IntermodalDetailsCardProps extends PropsWithChildren {}

export function IntermodalDetailsCard({ children }: IntermodalDetailsCardProps) {
  return (
    <Cardy flex={1} style={{ padding: '20px 4px' }}>
      {children}
    </Cardy>
  );
}
